import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  showMore: {
    id: 'generic.expandable-card.showMore.button',
    defaultMessage: 'Show More',
    description: 'Button text shown when card is collapsed',
  },
  showLess: {
    id: 'generic.expandable-card.showLess.button',
    defaultMessage: 'Show Less',
    description: 'Button text shown when card is expanded',
  },
});

export default messages;
